exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Menubar_menubar__2WV0N {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  -webkit-flex-wrap: nowrap;\n          flex-wrap: nowrap;\n  width: 70px;\n  height: 100%;\n  background-color: #fafbfc; }\n  .Menubar_menubar__2WV0N .Menubar_logo__3N3_P {\n    margin: 25px auto;\n    width: 50px;\n    height: 50px; }\n  .Menubar_menubar__2WV0N .Menubar_menuItem__3RVl6 {\n    display: -webkit-flex;\n    display: flex;\n    -webkit-justify-content: center;\n            justify-content: center;\n    width: 100%;\n    padding: 18px 12px;\n    box-sizing: border-box; }\n    .Menubar_menubar__2WV0N .Menubar_menuItem__3RVl6 .Menubar_icon__1X7xA {\n      font-size: 30px;\n      color: #adadad; }\n", ""]);

// exports
exports.locals = {
	"menubar": "Menubar_menubar__2WV0N",
	"logo": "Menubar_logo__3N3_P",
	"menuItem": "Menubar_menuItem__3RVl6",
	"icon": "Menubar_icon__1X7xA"
};